import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/smart-tasks/chat-ai/[[...slug]]/page.tsx")